export const SALESFORCE_DEPLOYMENT_ID = '5724T000000Cw2U';
export const SALESFORCE_ORGANIZATION_ID = '00DA0000000Yd7m';
export const SALESFORCE_CLIENT_ID = '5734T000000Xus0';
